import { useNavigate, NavLink, useParams, useLocation } from "react-router-dom";
import styles from "./Customer.module.css";
import Button from "./Button";
import React, { useEffect, useState } from "react";
import AddOtherItemModal from "../modals/AddOtherItemModal";
import { validateForm } from "../helpers/helperFunctions";
import dateFormat, { masks } from "dateformat";
import { displayUtcDate } from "../helpers/helperFunctions";
import Sidebar from "./Sidebar";
import MainMenu from "../menus/MainMenu";

function Customer({ props, setEditModal, getCustomers }) {
  const { id } = useParams();
  const returnLocation = useLocation();
  const [customer, setCustomer] = useState({});
  const [customerHistory, setCustomerHistory] = useState([]);
  const [custId, setCustId] = useState(0);
  const navigate = useNavigate();
  const [showDeletedEvents, setShowDeletedEvents] = useState(false);

  useEffect(() => {
    let customerId;
    if (props != undefined) {
      customerId = props.idCustomers;
    } else {
      customerId = id;
    }
    setCustId(customerId);
    getCustomerById(customerId);
  }, []);

  const makeInvalid = (e) => {
    e.target.classList.add("invalid");
  };

  const getCustomerById = async (custId) => {
    const res = await fetch("/api/customers/" + custId);
    const data = await res.json();
    await setCustomer(data.customer);
    await setCustomerHistory(data.history);
  };

  const updatePhoneNumber = (e) => {
    let tele = e.value;
    tele = tele.replace(/[^0-9]/g, "");
    let returnVal;
    if (tele.length > 2 && tele.length < 5) {
      returnVal = tele.slice(0, 3) + "-" + tele.slice(3);
    } else if (tele.length > 5 && tele.length < 11) {
      returnVal = tele.slice(0, 3) + "-" + tele.slice(3, 6) + "-" + tele.slice(6, 10);
    } else if (tele.length > 10) {
      returnVal = tele.slice(0, 3) + "-" + tele.slice(3, 6) + "-" + tele.slice(6, 10);
    }
    setCustomer({ ...customer, Phone: returnVal });
  };

  const handleClose = () => {
    if (props != undefined) {
      setEditModal({ show: false, props: null });
    } else {
      window.location.href = returnLocation.state.from;
    }
  };

  const handleShowDeleted = () => {
    setShowDeletedEvents(!showDeletedEvents);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm(e.target)) {
      await fetch("/api/customers/" + custId, {
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(customer),
      })
        .then((res) => res.json())
        .then((data) => {
          //navigate("/customers");
          if (props != undefined) {
            getCustomers();
            setEditModal({ show: false, props: null });
          } else {
            window.location.href = returnLocation.state.from;
          }
        });
    }
  };

  return (
    <>
      <section className={props != undefined ? styles.addCustomerFixed : styles.addCustomer}>
        <h2>Edit Customer {custId}</h2>
        <div className={styles.customerDetail}>
          <form className="form" onSubmit={handleSubmit} noValidate>
            <div className="formRow">
              <label>First Name</label>
              <input
                type="text"
                id="firstname"
                name="firstname"
                tabIndex={1}
                value={customer.FirstName}
                onChange={(e) => setCustomer({ ...customer, FirstName: e.target.value })}
              />
            </div>
            <div className="formRow">
              <label>Last Name</label>
              <input
                type="text"
                id="lastname"
                name="lastname"
                tabIndex={2}
                value={customer.LastName}
                onChange={(e) => setCustomer({ ...customer, LastName: e.target.value })}
              />
            </div>
            <div className="formRow">
              <label>Company</label>
              <input
                type="text"
                id="company"
                name="company"
                tabIndex={2}
                value={customer.CompanyName}
                onChange={(e) => setCustomer({ ...customer, CompanyName: e.target.value })}
              />
            </div>
            <div className="formRow">
              <label>E-Mail</label>
              <input
                type="email"
                id="email"
                name="email"
                tabIndex={3}
                value={customer.Email}
                onInvalid={makeInvalid}
                onChange={(e) => setCustomer({ ...customer, Email: e.target.value })}
              />
            </div>
            <div className="formRow">
              <label>Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                tabIndex={4}
                value={customer.Phone}
                onInvalid={makeInvalid}
                onChange={(e) => updatePhoneNumber(e.target)}
              />
              <div className="invalid-feedback">Phone number required or format should be 555-555-1212</div>
            </div>
            <div className="formRow">
              <label>Address 1</label>
              <input
                type="text"
                id="address1"
                name="address1"
                tabIndex={5}
                value={customer.Address1}
                onChange={(e) => setCustomer({ ...customer, Address1: e.target.value })}
              />
            </div>
            <div className="formRow">
              <label>Address 2</label>
              <input
                type="text"
                id="address2"
                name="address2"
                tabIndex={6}
                value={customer.Address2}
                onChange={(e) => setCustomer({ ...customer, Address2: e.target.value })}
              />
            </div>
            <div className="formRow">
              <label>Address 3</label>
              <input
                type="text"
                id="address3"
                name="address3"
                tabIndex={7}
                value={customer.Address3}
                onChange={(e) => setCustomer({ ...customer, Address3: e.target.value })}
              />
            </div>
            <div className="formRow">
              <label>City</label>
              <input
                type="text"
                id="city"
                name="city"
                tabIndex={8}
                value={customer.City}
                onChange={(e) => setCustomer({ ...customer, City: e.target.value })}
              />
            </div>
            <div className={styles.stateZip}>
              <div className="formRow">
                <label>State</label>
                <input
                  type="text"
                  id="state"
                  name="state"
                  tabIndex={9}
                  value={customer.State}
                  onChange={(e) => setCustomer({ ...customer, State: e.target.value })}
                />
              </div>
              <div className="formRow">
                <label>Zip</label>
                <input
                  type="text"
                  id="zip"
                  name="zip"
                  tabIndex={10}
                  value={customer.Zip}
                  onChange={(e) => setCustomer({ ...customer, Zip: e.target.value })}
                />
              </div>
            </div>
            <div className="formRow formRow-checkbox">
              <label>Active</label>
              <input
                type="checkbox"
                id="active"
                name="active"
                tabIndex={11}
                checked={customer.Deleted == "Y" ? false : true}
                onChange={(e) =>
                  setCustomer({
                    ...customer,
                    Deleted: e.target.checked ? "N" : "Y",
                  })
                }
              />
            </div>
            <div className={styles.saveButtons}>
              <Button type="primary">Save</Button>

              <Button onClick={handleClose} type="pOutline">
                Cancel
              </Button>
            </div>
          </form>
          {customerHistory.length > 0 && (
            <div className={styles.customerHistory}>
              <h3>Banquet History</h3>
              <table className={styles.banquetHistory}>
                <thead>
                  <tr>
                    <th>Banquet Name</th>
                    <th>Banquet Date</th>
                    <th>
                      <Button type="pOutline" onClick={handleShowDeleted}>
                        Show Deleted Events
                      </Button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(customerHistory) &&
                    customerHistory
                      .filter((item) => {
                        if (!showDeletedEvents) {
                          if (item.Deleted == "N") {
                            return true;
                          }
                        } else if (showDeletedEvents) {
                          return true;
                        }
                        return false;
                      })
                      .map((hs) => {
                        if (new Date(hs.BanDate).getFullYear() > 2021) {
                          return (
                            <tr key={hs.BanDate}>
                              <td>
                                <NavLink to={`/event/${hs.idBanquetHeader}`}>{hs.BanquetName}</NavLink>
                              </td>
                              <td>{dateFormat(displayUtcDate(hs.BanDate), "mmmm d, yyyy")}</td>
                              <td>{hs.Deleted == "Y" ? "(DELETED)" : ""}</td>
                            </tr>
                          );
                        }
                      })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default Customer;
